import { Divider, Typography } from "@mui/material";
import React from "react";
// import OverflowTooltip from "../../../../../../Reuse/UI/OverflowTooltip";
// import OverflowTooltips from "../../../../../../Reuse/UI/OverflowTooltips";
import StyleStack from "../../../../../../Reuse/UI/StyleStack";
import OverflowTooltip from "../../../../../../Reuse/UI/OverflowTooltip";

const Title = React.memo((props) => {
  const {
    title = "100.1",
    title1 = "",
    status = "AVAILABLE",
    divStatus = "available",
  } = props;
  return (
    <StyleStack gap={0.5} direction={"row"} sx={{ border: "none" }}>
      <OverflowTooltip variant="h5">{title}</OverflowTooltip>
      <Divider orientation="vertical" flexItem sx={{ borderRadius: 0.25 }} />
      <OverflowTooltip variant="h5">{title1}</OverflowTooltip>
      <OverflowTooltip
        component="span"
        variant={"h5"}
        sx={{ color: divStatus === "available" ? "#039855" : "#E62E05" }}
      >
        {status}
      </OverflowTooltip>
    </StyleStack>
  );
});

export default Title;
